import { CVStepLanguagesSchema } from 'schemas/cv-steps'
import { z } from 'zod'

const cVStepLanguagesValidator = CVStepLanguagesSchema.superRefine(
  (obj, ctx) => {
    // Do not use duplicate language
    const languages = obj.languages.map((c) => c.language)
    const uniqueLanguages = new Set(languages)
    if (languages.length !== uniqueLanguages.size) {
      ctx.addIssue({
        path: ['languages'],
        code: z.ZodIssueCode.custom,
        message: 'custom.noDuplicateLangs'
      })
    }
  }
)

export type ICVStepLanguagesValidator = z.infer<typeof cVStepLanguagesValidator>

export default cVStepLanguagesValidator
